import { Pipe, PipeTransform } from "@angular/core";
import { QuestionnaireResponseService } from "@zitelab/ionic-fhir-questionnaires";
import { calculateWho5 } from "../utils/calculate-who5";
/*
 * Adds a dash between the sixth and seventh digits of the CPR number
 */
@Pipe({ name: "who5" })
export class Who5 implements PipeTransform {
  constructor(private questionnaireResponse: QuestionnaireResponseService) {}
  transform(value: fhir.QuestionnaireResponse): number {
    if (value === null) {
      return null;
    }
    const answers = this.questionnaireResponse.extractAnswersFromQuestionnaireResponse(
      value
    );
    return calculateWho5(answers).score;
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/who5-pipe.ts